import { render, staticRenderFns } from "./FormsReport.vue?vue&type=template&id=06dec243&scoped=true&"
import script from "./FormsReport.vue?vue&type=script&lang=js&"
export * from "./FormsReport.vue?vue&type=script&lang=js&"
import style0 from "./FormsReport.vue?vue&type=style&index=0&id=06dec243&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dec243",
  null
  
)

export default component.exports